import { render, staticRenderFns } from "./container-html.vue?vue&type=template&id=8ff40a8c&scoped=true&"
import script from "./container-html.vue?vue&type=script&lang=js&"
export * from "./container-html.vue?vue&type=script&lang=js&"
import style0 from "./container-html.vue?vue&type=style&index=0&id=8ff40a8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff40a8c",
  null
  
)

export default component.exports